import { styled, spacing, Text, mq } from '@thg-commerce/enterprise-theme'
import { Button } from '@thg-commerce/gravity-elements'
import { Grid, GridItem } from '@thg-commerce/gravity-system'
import { HorizontalAlignment } from '@thg-commerce/enterprise-core'
import { SocialEmbed } from '@thg-commerce/enterprise-widget-social-embed'

export const Container = styled.div`
  padding: ${spacing(1)} 0};
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    padding: ${spacing(2)} 0;
  }
`

export const Title = styled.h2<{ alignment?: HorizontalAlignment }>`
  ${Text('large1', 'alternate')}
  text-align: ${(props) => props.alignment || 'center'};
`

export const Subtitle = styled.p<{ alignment?: HorizontalAlignment }>`
  ${Text('bodyText', 'default')}
  margin-top: ${spacing(1)};
  text-align: ${(props) => props.alignment || 'center'};
`

export const PreviewImageContainer = styled.div<{ hideImage: boolean }>`
  ${(props) => props.hideImage && 'display: none;'}
  position: relative;
  margin-bottom: ${spacing(2)};
`

export const PlayButton = styled(Button)`
  position: absolute;
  left: ${spacing(2)};
  bottom: ${spacing(2)};

  button,
  button:hover,
  button:focus {
    font-weight: 900;
  }

  svg {
    margin-right: ${spacing(1)};
    path {
      fill: ${(props) => props.theme.colors.palette.greys.white};
    }
  }
`

export const HighlightText = styled.p`
  ${Text('small', 'alternate')};
`

export const ItemTitle = styled.h3`
  ${Text('medium1', 'alternate')}
  margin-top: ${spacing(1)};
`

export const Content = styled.p`
  ${Text('bodyText', 'default')};
  margin-top: ${spacing(1)};
`

export const StyledButton = styled(Button)`
  margin-top: ${spacing(2)};
`

export const StyledGrid = styled(Grid)<{ alignment?: HorizontalAlignment }>`
  margin-top: ${spacing(3)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin-top: ${spacing(4)};
  }

  ${(props) => props.alignment && `text-align: ${props.alignment}`};
`

export const VideoGalleryGridItem = styled(GridItem)`
  margin-bottom: ${spacing(3)}
    ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin-bottom: ${spacing(4)};
  }
`

export const ModalTitle = styled.h2`
  ${Text('large1', 'alternate')}
  margin-bottom: ${spacing(1)}
`

export const StyledSocialEmbed = styled(SocialEmbed)`
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    display: none;
  }
`
